import { Typography } from "@mui/material";
import React from "react";
import MailIcon from "@mui/icons-material/Mail";
import CallIcon from "@mui/icons-material/Call";
import RoomIcon from "@mui/icons-material/Room";
import { useTranslation } from "react-i18next";

export default function ContactUs() {
  const { t } = useTranslation();
  return (
    <div
      id="contact"
      style={{
        width: "500px",
        backgroundColor: "#FFFFFF",
        boxShadow: "10px 10px 10px #E1E2E4FF",
        borderRadius: "20px",
        marginBottom: "5%",
        padding: "20px",
      }}
    >
      <Typography sx={{ color: "#0F237A", fontWeight: "bold" }}>
        <MailIcon /> info@focustradingcompany.com{" "}
      </Typography>
      <br />

      <Typography sx={{ color: "#0F237A", fontWeight: "bold" }}>
        <CallIcon /> 011 4840{" "}
      </Typography>
      <br />
      <Typography sx={{ color: "#0F237A", fontWeight: "bold" }}>
        <CallIcon /> 011 2232 245{" "}
      </Typography>
      <br />

      <Typography sx={{ color: "#0F237A", fontWeight: "bold" }}>
        <CallIcon /> 011 2232 246{" "}
      </Typography>
      <br />

      <Typography sx={{ color: "#0F237A", fontWeight: "bold" }}>
        <RoomIcon /> {t("Damascus , Al- Fardos Tower")}{" "}
      </Typography>
      <br />
    </div>
  );
}
